import { Quaternion } from "@babylonjs/core/Maths/math.vector";
import { Matrix, Vector3 } from "@babylonjs/core/Maths/math.vector";
import { PhysicsBoxShape, PhysicsCapsuleShape, PhysicsSphereShape } from "../physicsShape";
const TempVector3 = new Vector3();
function LocalTransformMatrixFromTranslationRotationToRef(center, rotation, matrix) {
    if (center?.equalsToFloats(0, 0, 0) === false ||
        rotation?.equalsToFloats(0, 0, 0, 1) === false) {
        if (rotation !== undefined) {
            if (matrix === undefined) {
                matrix = new Matrix();
            }
            matrix = Matrix.FromQuaternionToRef(rotation, matrix);
            if (center !== undefined) {
                matrix.setTranslation(center);
            }
        }
        else if (center !== undefined) {
            if (matrix === undefined) {
                matrix = Matrix.Identity();
            }
            else {
                Matrix.IdentityToRef(matrix);
            }
            matrix.setTranslation(center);
        }
        else {
            if (matrix === undefined) {
                matrix = Matrix.Identity();
            }
            else {
                Matrix.IdentityToRef(matrix);
            }
        }
        return matrix;
    }
    else {
        return null;
    }
}
export class PluginBoxShape extends PhysicsBoxShape {
    localTransform;
    collisionGroup = 1;
    collisionMask = 0xFFFF;
    _material = null;
    constructor(runtime, center, rotation, extents = new Vector3(1.0, 1.0, 1.0)) {
        super(runtime, extents.scaleToRef(0.5, TempVector3));
        this.localTransform = LocalTransformMatrixFromTranslationRotationToRef(center, rotation);
    }
    setMaterial(friction, restitution) {
        this._material = { friction, restitution };
    }
    get material() {
        return this._material;
    }
}
export class PluginSphereShape extends PhysicsSphereShape {
    localTransform;
    collisionGroup = 1;
    collisionMask = 0xFFFF;
    _material = null;
    constructor(runtime, center, radius = 1.0) {
        super(runtime, radius);
        this.localTransform = LocalTransformMatrixFromTranslationRotationToRef(center);
    }
    setMaterial(friction, restitution) {
        this._material = { friction, restitution };
    }
    get material() {
        return this._material;
    }
}
export class PluginCapsuleShape extends PhysicsCapsuleShape {
    localTransform;
    collisionGroup = 1;
    collisionMask = 0xFFFF;
    _material = null;
    constructor(runtime, pointA = new Vector3(0, 0, 0), pointB = new Vector3(0, 1, 0), radius = 0) {
        const height = Vector3.Distance(pointA, pointB);
        super(runtime, radius, height);
        const direction = pointB.subtract(pointA);
        direction.normalize();
        const quaternion = Quaternion.FromUnitVectorsToRef(Vector3.Up(), direction, new Quaternion());
        this.localTransform = LocalTransformMatrixFromTranslationRotationToRef(pointA, quaternion);
    }
    setMaterial(friction, restitution) {
        this._material = { friction, restitution };
    }
    get material() {
        return this._material;
    }
}
